module.exports = __webpack_public_path__ + "videos/whats-new-53-colordrop_16x9_jp.836f805.mp4";